module.exports = {versao:  18 ,
track:"https://s-track.untaxi.com.br",
old:false,
url:"https://s-api.untaxi.com.br"};
